/**
 * Sample values used to prefill the clear-sample wizards while developing.
 *
 * Only applied when the dev server is running: `process.env.NODE_ENV` is
 * inlined at build time, so the fixtures are dropped from production bundles.
 *
 * File inputs and the autocompletes backed by the selects API are left empty on
 * purpose - a plain string cannot stand in for a File, and an option that was
 * never fetched will not match.
 */

const isDev = process.env.NODE_ENV === "development";

const FIXTURES = {
    sample: {
        name: "Dev Tester",
        email: "dev.tester@example.com",
        label_id: "Dev Records",
        distribution_id: "Dev Distribution",
        business_address: "1600 Amphitheatre Parkway, Mountain View, CA 94043",
        phone_number: "4155550132",
        party_responsible_payment: "Dev Tester",
        author_sign_sample_agreement: "Dev Tester",
        party_payment_email: "billing.dev@example.com",
        // Stands in for the URL the upload endpoint returns, so step 2 can be
        // passed without uploading audio. The dropzone still shows as empty.
        song_url: "https://example.com/dev-placeholder-song.mp3",
        artist_name: "Dev Artist",
        song_new_name: "Dev Sample Track",
        song_writers: ["Dev Writer"],
        song_publishers: ["Dev Publisher"],
        sampled_name: "Original Dev Song",
        sampled_link: "https://www.youtube.com/watch?v=dQw4w9WgXcQ",
        sampled_artist_name: "Original Dev Artist",
        sampled_labels: ["Original Dev Records"],
        sampled_writers: ["Original Dev Writer"],
        sampled_publishers: ["Original Dev Publisher"],
        description: "Four bars of the intro drum break, looped under the first verse.",
        deadline: "12/31/26",
        type_of_used: "both",
    },
    sync: {
        name: "Dev Tester",
        email: "dev.tester@example.com",
        your_company: "Dev Productions LLC",
        distribution: "Dev Distribution",
        business_address: "1600 Amphitheatre Parkway, Mountain View, CA 94043",
        phone_number: "4155550132",
        party_responsible_payment: "Dev Tester",
        author_sign_sample_agreement: "Dev Tester",
        party_payment_email: "billing.dev@example.com",
        track_title: "Dev Sync Track",
        track_link: "https://www.youtube.com/watch?v=dQw4w9WgXcQ",
        label: ["Dev Records"],
        artists: ["Dev Artist"],
        project_title: "Dev Documentary",
        project_budget: "50000",
        project_synopsis: "A short documentary about building software at 2am.",
        description_of_use: "Plays under the closing montage for roughly ninety seconds.",
        length_use: "01:30",
        release_air_date: "12/31/26",
        proposed_free: "2500",
        publishing_or_master_sync_used: "other",
        sync_other_used: "Both publishing and master.",
    },
    digitalLicense: {
        name: "Dev Tester",
        email: "dev.tester@example.com",
        label: "Dev Records",
        business_address: "1600 Amphitheatre Parkway, Mountain View, CA 94043",
        phone_number: "4155550132",
        performing_artist: "Dev Artist",
        song_name: "Dev License Track",
        song_url: "https://www.youtube.com/watch?v=dQw4w9WgXcQ",
        artist_name: "Dev Artist",
        album_title: "Dev Sessions",
        format: "digital",
        amount: "1000",
        upc_catalog: "012345678905",
        ISRC: "USRC17607839",
        time: "03:45",
        release_date: "12/31/26",
    },
    review: {
        firstname: "Dev",
        lastname: "Tester",
        phone: "4155550132",
        email: "dev.tester@example.com",
        company_name: "Dev Productions LLC",
        label: "Dev Records",
        project_background: "Independent release, no label attached yet.",
        question: "Does the intro loop need clearing before release?",
        song_url: "https://www.youtube.com/watch?v=dQw4w9WgXcQ",
    },
};

/**
 * @param {"sample"|"sync"|"digitalLicense"|"review"} key which wizard to prefill
 * @returns {Object} a fresh copy of the fixture, or an empty object outside development
 */
export function devFormDefaults(key) {
    if (!isDev) return {};
    return { ...FIXTURES[key] };
}

export default devFormDefaults;
